export var TreeEntryType;
(function (TreeEntryType) {
    TreeEntryType["TREE_ENTRY_TYPE_FILE"] = "FILE";
    TreeEntryType["TREE_ENTRY_TYPE_DIR"] = "DIR";
    TreeEntryType["TREE_ENTRY_TYPE_SYMLINK"] = "SYMLINK";
    TreeEntryType["TREE_ENTRY_TYPE_SUBMODULE"] = "SUBMODULE";
})(TreeEntryType || (TreeEntryType = {}));
